import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import useLayoutStyles from './useLayoutStyles';
import SideBarNav from '../main/sideBarNav';
import Header from '../header';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setSearchString } from '../../redux/slices/questionsSlice';
import { setSidebarOpen, sidebarOpenSelector } from '../../redux/slices/layoutSlice';

/**
 * Main component represents the layout of the main page, including a sidebar and the main content area.
 */
const Layout = () => {
  const { classes } = useLayoutStyles();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';

  const sidebarOpen = useAppSelector(sidebarOpenSelector);
  const handleOverlayClick = () => dispatch(setSidebarOpen(false));

  useEffect(() => {
    dispatch(setSearchString(searchQuery));
  }, [dispatch, searchQuery]);

  return (
    <>
      <Header />
      <div id='main' className={classes.main}>
        {sidebarOpen && (
          <div
            id='right_main_overlay'
            className={classes.rightMainOverlay}
            onClick={handleOverlayClick}></div>
        )}
        <div id='right_main' className={classes.rightMain}>
          <Outlet />
        </div>
        {sidebarOpen && <SideBarNav />}
      </div>
    </>
  );
};

export default Layout;
